const dataUrlPattern = /^\s*data:([a-z]+\/[a-z]+(;[a-z-]+=[a-z-]+)?)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;

/**
 * Returns whether a string is a data URL.
 */
export function isDataUrl(value: string | null | undefined): boolean {
  return dataUrlPattern.test(value ?? '');
}
